export default function getClientId() {
    return new Promise((resolve) => {
        if (typeof window.ga !== 'undefined') {
            window.ga(() => {
                let clientId;
                window.ga.getAll().forEach(tracker => {
                    clientId = clientId || tracker.get('clientId');
                });
                resolve(clientId || 'unknown');
            });
        } else {
            resolve('unknown');
        }
    });
}
